import React, { useState, useEffect } from 'react';
import { Stack, TextField } from '@mui/material';
import { useSearchParams } from 'react-router-dom';
import { useAppDispatch } from '../../../../../app/hooks';
import { useUpsertRuleMutation, useDeleteRuleMutation, contractApi } from '../../../../../services/ContractService';
import { RuleCommands } from './RuleCommands';

interface PerDayAddOnProps {
  ruleId: string;
  ruleString?: string;
  ruleDescription?: string;
}

interface PerDayAddOnRule {
  rate: number;
}

const PerDayAddOn: React.FC<PerDayAddOnProps> = ({
  ruleId,
  ruleString,
  ruleDescription,
}) => {
  const [searchParams] = useSearchParams();
  const contractId = searchParams.get('id');
  const dispatch = useAppDispatch();
  const [rule, setRule] = useState<PerDayAddOnRule>({ rate: 0 });
  
  const [upsertRule] = useUpsertRuleMutation();
  const [deleteRule] = useDeleteRuleMutation();

  useEffect(() => {
    if (ruleString && ruleString !== '') {
      try {
        const parsedRule: PerDayAddOnRule = JSON.parse(ruleString);
        setRule(parsedRule);
      } catch (error) {
        console.error('Failed to parse rule string:', error);
      }
    }
  }, [ruleString, ruleId]);

  const save = async () => {
    if (!contractId) return;

    try {
      const ruleData = {
        contractId: contractId,
        ruleId: ruleId === '0' ? '' : ruleId,
        ruleType: 'PerDayAddOn',
        priority: 0,
        ruleString: JSON.stringify(rule),
        description: ruleDescription ?? '',
      };

      await upsertRule(ruleData).unwrap();
      dispatch(contractApi.util.invalidateTags(['RuleList']));
    } catch (error) {
      console.error('Failed to save rule:', error);
    }
  };

  const ruleDelete = async () => {
    if (ruleId === '0') return;

    try {
      await deleteRule({ ruleId }).unwrap();
      dispatch(contractApi.util.invalidateTags(['RuleList']));
    } catch (error) {
      console.error('Failed to delete rule:', error);
    }
  };

  return (
    <React.Fragment>
      <Stack direction="row" gap={1} sx={{ mb: 2 }}>
        <TextField
          type="number"
          label="Rate"
          size="small"
          value={rule.rate}
          onChange={(e) => setRule({ ...rule, rate: Number(e.target.value) })}
          sx={{ width: '100px' }}
          inputProps={{ step: 0.01 }}
          InputLabelProps={{ shrink: true }}
        />
      </Stack>
      <RuleCommands
        saveCommand={save}
        deleteCommand={ruleDelete}
        isNewRule={ruleId === '0'}
      />
    </React.Fragment>
  );
};

export { PerDayAddOn };